<template>
  <v-navigation-drawer
    app
    right
    clipped
    width="290"
    v-model="model"
  >
    <perfect-scrollbar style="height: 100%">
      <div class="mt-4 mx-2" >
        <date-selection />
        <cell-selection />
        <shift-selection />
      </div>
    </perfect-scrollbar>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import DateSelection from './filters/DateSelection.vue';
import ShiftSelection from './filters/ShiftSelection.vue';
import CellSelection from './filters/CellSelection.vue';

export default {
  name: 'ManpowerDrawer',
  components: {
    DateSelection,
    ShiftSelection,
    CellSelection,
  },
  computed: {
    ...mapState('manpowerLog', ['drawer']),
    model: {
      get() {
        return this.drawer;
      },
      set(val) {
        this.setDrawer(val);
      },
    },
  },
  methods: {
    ...mapMutations('manpowerLog', ['setDrawer']),
  },
};
</script>
